const deviceTypes = {
  farmstand: 'farmstand',
  v2: 'v2',
};

export const V2_SIZE = 20;

export default deviceTypes;
